// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';
//vuex状态管理组件
import store from './vuex/store' // 引入store
//iview框架
import 'iview/dist/styles/iview.css';
import 'animate.css'
//设置页面 title的组件
import VueWechatTitle from 'vue-wechat-title';
import Routel from './routel';
/**
 * 基于photoswipe的vue图片预览组件
 */
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

Vue.use(preview);
Vue.use(VueWechatTitle)
Vue.use(iView);

Vue.config.productionTip = false;
Vue.prototype.baseUrl=Routel.url;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js